import { chartLightOptions } from '../constant';
import { CustomSeriesOptions, customSeriesDefaultOptions, IRange } from 'lightweight-charts';

export interface CustomLineStyle {
  lineColor: string;
  lineWidth: number;
  customColor: string;
}

export interface CustomLineSeriesOptions extends CustomSeriesOptions, CustomLineStyle {
  customRange: IRange<number>;
  label?: string;
}

export const defaultOptions: CustomLineSeriesOptions = {
  ...customSeriesDefaultOptions,
  lineColor: chartLightOptions.lineColor,
  lineWidth: chartLightOptions.lineWidth,
  customColor: chartLightOptions.lineColor,
  customRange: { from: 0, to: 0 },
} as const;
